export default __webpack_public_path__ + "static/media/029-triangle.d54769ca.svg";